import React, { memo, useEffect, useMemo, useState } from "react";
import { useToastrContext } from "../Provider/ToastrProvider";
import { FUNCTION_IDENTIFIER, IDENTIFIER } from "../FormGenerator/constants";
import FormGenerator from "../FormGenerator";
import { getStateList } from "../../views/SiteManagement/City/api";
import { getCountryList } from "../../views/SiteManagement/State/api";
import { getCityList } from "../../views/SiteManagement/TravelPartners/api";


const LocationFilter = ({ handleSubmit, isCustomer = false, isHotel = false }) => {
  const [countryLists, setCountryLists] = useState([]);
  const [stateLists, setStateLists] = useState([]);
  const [cityLists, setCityLists] = useState([]);

  const { errorResponseHandler } = useToastrContext();

  const fetchCountryList = async () => {
    try {
      const result = await getCountryList();
      const data = result?.data?.data?.map((row) => ({
        label: row?.name,
        value: row?.id,
      }));
      setCountryLists(data);
    } catch (error) {
      errorResponseHandler(error);
    }
  };

  const fetchStateList = async (countryId) => {
    try {
      if (!countryId) return setStateLists([]);
      const result = await getStateList(countryId);
      const data = result?.data?.data?.map((row) => ({
        label: row?.name,
        value: row?.id,
      }));
      setStateLists(data);
    } catch (error) {
      errorResponseHandler(error);
    }
  };

  const fetchCityList = async (countryId) => {
      try {
        if (!countryId) return setCityLists([]);
        const result = await getCityList(countryId);
        const data = result?.data?.data?.map((row) => ({label: row?.name, value: row?.id}));
        setCityLists(data);
      } catch (error) {
        errorResponseHandler(error);
      }
    };

  useEffect(() => {
    fetchCountryList();
  }, []);

  const formFields = useMemo(
    () => ({
      fields: [
        {
          name: "countryId",
          label: "Country",
          type: IDENTIFIER.SELECT,
          options: countryLists,
          functionMethod: FUNCTION_IDENTIFIER.ON_CHANGE,
          functionChangeBaseOn: "countryId",
          customFunction: async (value, setValue) => {
            await fetchStateList(value?.countryId);
            setValue("stateId", "");
            setValue("cityId", "");
          },
          alignment: {
            sm: 12,
            md: 3,
            lg: 3,
          },
        },
        {
          name: "stateId",
          label: "State",
          type: IDENTIFIER.SELECT,
          options: stateLists,
          functionMethod: FUNCTION_IDENTIFIER.ON_CHANGE,
          functionChangeBaseOn: "stateId",
          customFunction: async (value, setValue) => {
            await fetchCityList(value?.stateId);
            setValue("cityId", "");
          },
          alignment: {
            sm: 12,
            md: 3,
            lg: 3,
          },
        },
        {
          name: "cityId",
          label: "City",
          type: IDENTIFIER.SELECT,
          options: cityLists,
          alignment: {
            sm: 12,
            md: 3,
            lg: 3,
          },
        },
        {
          name: "mobile",
          label: "Mobile",
          type: IDENTIFIER.INPUTNUMBER,
          alignment: {
            sm: 12,
            md: 3,
            lg: 3,
          },
        },
        {
          name: "email",
          label: "Email",
          type: IDENTIFIER.INPUTTEXT,
          alignment: {
            sm: 12,
            md: 3,
            lg: 3,
          },
        },
        {
          name: "gstNo",
          label: "GST No",
          type: IDENTIFIER.INPUTTEXT,
          alignment: {
            sm: 12,
            md: 3,
            lg: 3,
          },
        },
        ...(isCustomer ? [{
          name: "gstName",
          label: "Company Name",
          type: IDENTIFIER.INPUTTEXT,
          alignment: {
            sm: 12,
            md: 3,
            lg: 3,
          },
        },
        {
          name: "name",
          label: "Customer Name",
          type: IDENTIFIER.INPUTTEXT,
          alignment: {
            sm: 12,
            md: 3,
            lg: 3,
          },
        },
      ] : []),
        ...(isHotel ? [{
          name: "name",
          label: "Hotel Name",
          type: IDENTIFIER.INPUTTEXT,
          alignment: {
            sm: 12,
            md: 3,
            lg: 3,
          },
        }] : []),
      ],
    }),
    [countryLists, stateLists, cityLists]
  );

  return (
    <FormGenerator
      formConfig={formFields}
      onSubmit={handleSubmit}
      buttonName="Search"
      isSearch="3"
    />
  );
};

export default memo(LocationFilter);
